/**
 * Main theme configuration
 * Combines palette, typography, and component overrides
 */

import { createTheme, ThemeOptions } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { components } from './components';

const commonOptions: Omit<ThemeOptions, 'palette'> = {
  typography,
  components,
  shape: {
    borderRadius: 14,
  },
  spacing: 8,
};

export const lightTheme = createTheme({
  ...commonOptions,
  palette: lightPalette,
});

export const darkTheme = createTheme({
  ...commonOptions,
  palette: darkPalette,
});

export type ThemeMode = 'light' | 'dark' | 'auto';

/**
 * Get effective theme mode based on user preference and system preference
 */
export function getEffectiveMode(mode: ThemeMode): 'light' | 'dark' {
  if (mode === 'auto') {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'dark';
  }
  return mode;
}
